export const btnClear = {
    padding: "0",
    margin: "0 10px",
    backgroundColor: "inherit",
    border: "none"
}